<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("cinema", 1) }} {{ $t("tickettemplates") }}
      </div>
      <div>
        <router-link class="btn-blue" to="cinema-ticket-templates"
          >{{ $t("tickettemplates") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <!-- <label
              :class="ticketDetails.temp_name && ticketDetails.temp_name.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $t('tickettemplates') }}</label> -->
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="ticketDetails.temp_name" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(template, templateIndex) in TemplateList"
                  @click="OnSelectTemplate(template)"
                  :key="templateIndex"
                >{{template.t_name}}</b-dropdown-item>
              </b-dropdown> -->
              <custommultiselect
                :options="TemplateList"
                v-model="ticketDetails.temp_name"
                @select="OnSelectTemplate($event)"
                placeholder="Select Ticket Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('ticket_temp')" />
              <img
                v-if="ticketDetails.temp_name && TicketTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Ticket')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <span v-if="submitted && ticketDetails.temp_name.length == 0"
                >Please select ticket template.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown
                :text="ticketDetails.receipt_temp_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(rtemplate, rtemplateIndex) in ReceiptTemplateList"
                  @click="OnSelectReceiptTemplate(rtemplate)"
                  :key="rtemplateIndex"
                >{{rtemplate.rtemp_name}}</b-dropdown-item>
              </b-dropdown> -->
              <custommultiselect
                :options="ReceiptTemplateList"
                v-model="ticketDetails.receipt_temp_name"
                @select="OnSelectReceiptTemplate($event)"
                placeholder="Select Receipt Template"
                label="rtemp_name"
                :multiple="false"
                track-by="rtemp_id"
              ></custommultiselect>
              <Tooltip :title="$t('select_receipt_template')" />
              <img
                v-if="ticketDetails.receipt_temp_name && ReceiptTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Receipt')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <span
                v-if="submitted && ticketDetails.receipt_temp_name.length == 0"
                >Please select receipt template.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <custommultiselect
                :options="EmailTempList"
                v-model="selected_etemp"
                @select="onSelectTempNew($event, 'Email')"
                placeholder="Select Email Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('email_temp')" />
              <img
                v-if="selected_etemp && EmailTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Email')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <!-- <span
                v-if="submitted && ticketDetails.email_temp_name.length == 0"
              >Please select Email template.</span> -->
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <custommultiselect
                :options="SMSTempList"
                v-model="selected_stemp"
                @select="onSelectTempNew($event, 'SMS')"
                placeholder="Select SMS Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('sms_temp')" />
              <img
                v-if="selected_stemp && SMSTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('SMS')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
          </div>
          <p class="error_message">
            <!-- <span
                v-if="submitted && ticketDetails.sms_temp_name.length == 0"
              >Please select SMS template.</span> -->
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <custommultiselect
                :options="WhatsAppTempList"
                v-model="selected_wtemp"
                @select="onSelectTempNew($event, 'WhatsApp')"
                placeholder="Select WhatsApp Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('whatsapp_temp')" />
              <img
                v-if="selected_wtemp && WhatsAppTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('WhatsApp')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <!-- <span
                v-if="submitted && ticketDetails.whatsApp_temp_name.length == 0"
              >Please select WhatsApp template.</span> -->
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4" v-if="false">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <label :class="selected_refundtemp ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("Refund") }}
                {{ $t("template") }}</label
              >
              <custommultiselect
                :options="RefundTempList"
                v-model="selected_refundtemp"
                @select="onSelectTempNew($event, 'Refund')"
                placeholder="Select Refund Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('Refund Template')" />
              <img
                v-if="selected_refundtemp && RefundTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Refund')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <!-- <span
                v-if="submitted && ticketDetails.whatsApp_temp_name.length == 0"
              >Please select WhatsApp template.</span> -->
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4">
          <div class="d-flex align-items-center">
            <custommultiselect
              :options="validCinemas"
              v-model="ticketDetails.temp_cinema_id"
              placeholder="Select Cinemas"
              label="cine_name"
              :multiple="false"
              :disabled="isRoleID"
              track-by="cine_id"
            ></custommultiselect>
            <Tooltip :title="$t('select_cinemas')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && ticketDetails.temp_cinema_id.length == 0"
              >Please select cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="copies_name && copies_name.length > 0 ? 'shift-up' : ''"
              >{{ $t("copies") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="copies_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(copy, copyIndex) in copies"
                  @click="OnSelectCopies(copy)"
                  :key="copyIndex"
                  >{{ copy.name }}</b-dropdown-item
                >
              </b-dropdown>

              <Tooltip :title="$t('numCopies')" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="label_1"
                name="label_1"
                v-validate=""
                v-model="ticketDetails.label_1"
                placeholder="."
              />
              <label>Label 1</label>
            </div>
            <Tooltip :title="$t('label_1')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('label_1')">{{
              errors.first("label_1")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="label_2"
                name="label_2"
                v-validate=""
                v-model="ticketDetails.label_2"
                placeholder="."
              />
              <label>Label 2</label>
            </div>
            <Tooltip :title="$t('label_2')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('label_2')">{{
              errors.first("label_2")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="label_top_1"
                name="label_top_1"
                v-model="ticketDetails.label_top_1"
                placeholder="."
              />
              <label>Label Top 1</label>
            </div>
            <Tooltip :title="$t('label_top_1')" />
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_active"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $t("single") }} {{ $tc("seat", 1) }}
                {{ $tc("ticket", 1) }}</label
              >
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_single_Ticket"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12">
          <div class="section-title mb-3">
            {{ $tc("ticket", 1) }} {{ $t("content") }}
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $t("show") }} {{ $tc("cinema", 1) }} {{ $t("name") }}</label
              >
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_cinema_name"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("contactno") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_contact_number"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("show") }} {{ $t("address") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_show_address"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("support") }} {{ $t("email") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_email"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $tc("screen", 1) }} {{ $t("name") }}</label
              >
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_screen_name"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $tc("seat", 1) }} {{ $t("type") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_seat_type"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $tc("seat", 1) }} {{ $t("name") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_seat_name"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $t("tax") }} / {{ $tc("charge", 1) }}
                {{ $tc("details", 2) }}</label
              >
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_tax_details"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t('separate') }} {{ $tc('fb') }} {{ $t('bill') }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_fnb_bill"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>-->

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("datetime") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_datetime"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">QR {{ $t("code") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_qrcode"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("specialinstruction") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_special_instruction"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>

          <div v-if="ticketDetails.temp_special_instruction == 'Y'">
            <div class="d-flex align-items-center">
              <div class="input-material w-62">
                <input
                  v-model="ticketDetails.temp_special_text"
                  name="special_text"
                  id="special_text"
                  v-validate="'required'"
                  placeholder="."
                  type="text"
                />
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('special_text')">{{
                errors.first("special_text")
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="OnReset()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="cinema-ticket-templates"
            >{{ $t("cancel") }}</b-button
          >
        </div>
        <b-modal
          ref="preview-modal"
          id="selected-template-preview-modal"
          size="lg"
          :title="'Preview'"
          hide-footer
        >
          <div class="TempPreview">
            <div
              v-if="selectedType == 'Ticket'"
              v-html="TicketTempPreview"
            ></div>
            <div v-if="selectedType == 'SMS'" v-html="SMSTempPreview"></div>
            <div v-if="selectedType == 'Email'" v-html="EmailTempPreview"></div>
            <div
              v-if="selectedType == 'WhatsApp'"
              v-html="WhatsAppTempPreview"
            ></div>
            <div
              v-if="selectedType == 'Receipt'"
              v-html="ReceiptTempPreview"
            ></div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      validCinemas: [],
      cinemaList: [],
      submitted: false,
      cinema_name: "",
      copies_name: "",
      ticketDetails: {
        temp_id: null,
        temp_name: "",
        receipt_temp_id: null,
        receipt_temp_name: "",
        temp_cinema_id: [],
        temp_no_of_copies_id: "",
        temp_active: "Y",
        temp_single_Ticket: "Y",
        temp_cinema_name: "Y",
        temp_contact_number: "N",
        temp_show_address: "Y",
        temp_email: "N",
        temp_screen_name: "Y",
        temp_seat_type: "Y",
        temp_seat_name: "Y",
        temp_tax_details: "N",
        temp_fnb_bill: "N",
        temp_special_instruction: "N",
        temp_special_text: "",
        temp_datetime: "Y",
        temp_qrcode: "N",
        sms_temp_id: null,
        sms_temp_name: "",
        email_temp_id: null,
        email_temp_name: "",
        whatsApp_temp_id: null,
        whatsApp_temp_name: "",
        refund_temp_id: null,
        refund_temp_name: "",
        label_1: "",
        label_2: "",
        label_top_1: ""
      },
      copies: [],
      TemplateList: [],
      ReceiptTemplateList: [],
      SMSTempList: [],
      EmailTempList: [],
      WhatsAppTempList: [],
      RefundTempList: [],
      errmsg: "",
      selected_etemp: "",
      selected_stemp: "",
      selected_wtemp: "",
      selected_refundtemp: "",
      previewData: "",
      ModalTitle: "",
      selectedType: "",
      TicketTempPreview: "",
      SMSTempPreview: "",
      WhatsAppTempPreview: "",
      EmailTempPreview: "",
      ReceiptTempPreview: "",
      RefundTempPreview: "",
    };
  },
  computed: {
    CLIENT_SETUP_NAME() {
      console.log("CLIENT_SETUP_NAME", this.$store.getters.CLIENT_SETUP_NAME)
      return this.$store.getters.CLIENT_SETUP_NAME;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }

    this.noofcopies();
    this.ticketDetails.temp_no_of_copies_id = 1;
    this.copies_name = "1";

    this.getTicketTemplate();
    this.getReceiptTemplateList();
    this.getCinemaList(obj);
    this.getValidCinemaList(obj);
    // this.OnReset();
  },
  mounted() {},

  methods: {
    noofcopies: function() {
      this.copies = [
        { name: 1 },
        { name: 2 },
        { name: 3 },
        { name: 4 },
        { name: 5 },
        { name: 6 },
        { name: 7 },
        { name: 8 },
        { name: 9 },
        { name: 10 }
      ];
    },

    OnReset: function() {
      this.ticketDetails = {
        temp_id: null,
        temp_name: "",
        receipt_temp_id: null,
        receipt_temp_name: "",
        temp_cinema_id: [],
        temp_no_of_copies_id: 1,
        temp_active: "Y",
        temp_single_Ticket: "Y",
        temp_cinema_name: "Y",
        temp_contact_number: "N",
        temp_show_address: "Y",
        temp_email: "N",
        temp_screen_name: "Y",
        temp_seat_type: "Y",
        temp_seat_name: "Y",
        temp_tax_details: "N",
        temp_fnb_bill: "N",
        temp_special_instruction: "N",
        temp_special_text: "",
        temp_datetime: "Y",
        temp_qrcode: "N",
        label_1: "",
        label_2: ""
      };
      this.cinema_name = "";
      this.copies_name = "1";
      this.TicketTempPreview = "";
      this.SMSTempPreview = "";
      this.WhatsAppTempPreview = "";
      this.EmailTempPreview = "";
    },
    GetTicektTemplateDetails: function(id, type) {
      let body = {
        temp_id: id,
        flag: "View"
      };

      MasterService.GetTicketTemplate(body).then(response => {
        console.log("response :", response);
        if (type == "Ticket") {
          this.TicketTempPreview = response.data;
        } else if (type == "Email") {
          this.EmailTempPreview = response.data;
        } else if (type == "SMS") {
          this.SMSTempPreview = response.data;
        } else if (type == "WhatsApp") {
          this.WhatsAppTempPreview = response.data;
        } else if(type == "Refund") {
          this.RefundTempPreview = response.data;
        }
      });
    },
    GetReceiptTemplateDetails: function(id) {
      let payload = {
        rtemp_id: id,
        flag: "View"
      };

      MasterService.GetSingleReceiptTemplate(payload)
        .then(response => {
          const { data } = response;
          this.ReceiptTempPreview = data;
        })
        .catch(this._CatchError);
    },
    onPreview(type) {
      this.selectedType = type;
      this.$refs["preview-modal"].show();
    },
    getReceiptTemplateList: function() {
      let body = {
        limit: null,
        currentPage: null
      };
      MasterService.GetReceiptTemplate(body).then(response => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.ReceiptTemplateList = data.Records;
          }
        }
      });
    },

    getTicketTemplate: function() {
      let body = {
        limit: null,
        currentPage: null
      };

      MasterService.GetTicketTemplate(body).then(response => {
        const { data } = response;
        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            // this.TemplateList = data.Records;
            data.Records = data.Records.filter((x) => String(x.project_name).toLowerCase() == String(this.CLIENT_SETUP_NAME.toLowerCase()) || !x.project_name)
            this.TemplateList = data.Records.filter(x => x.type == "Ticket");
            this.SMSTempList = data.Records.filter(x => x.type == "SMS");
            this.EmailTempList = data.Records.filter(x => x.type == "Email");
            this.RefundTempList = data.Records.filter(x => x.type == "Refund");
            this.WhatsAppTempList = data.Records.filter(
              x => x.type == "WhatsApp"
            );
          }
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    getValidCinemaList(cine_id) {
      CinemasService.GetValidCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("data.Records valid :", data.Records);
            this.validCinemas = data.Records;
            this.validCinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.cinema_name = x.cine_name;
                this.ticketDetails.temp_cinema_id.push(x);
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
              }
            });
          } else {
            // Show Error Message:
            this.$toasted.show(data.message);
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch On GetInActiveCinemas :", error);
        });
    },

    getCinemaList: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })

        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            if (cine_id === undefined) {
            } else {
              this.cinemaList.map(x => {
                if (String(cine_id) === String(x.cinema_id)) {
                  this.cinema_name = x.cine_name;
                  this.ticketDetails.temp_cinema_id = x.cine_id;
                }
              });
            }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch On GetInActiveCinemas :", error);
        });
    },

    OnSelectCopies: function(copy) {
      this.ticketDetails.temp_no_of_copies_id = copy.name;
      this.copies_name = String(copy.name);
    },

    OnSelectTemplate: function(template) {
      this.TicketTempPreview = "";
      this.ticketDetails.temp_name = template.t_name;
      this.ticketDetails.temp_id = template.t_id;
      this.GetTicektTemplateDetails(template.t_id, "Ticket");
    },
    onSelectTempNew(template, type) {
      if (type == "Email") {
        this.EmailTempPreview = "";
        this.ticketDetails.email_temp_name = template.t_name;
        this.ticketDetails.email_temp_id = template.t_id;
        this.GetTicektTemplateDetails(template.t_id, "Email");
      } else if (type == "SMS") {
        this.SMSTempPreview = "";
        this.ticketDetails.sms_temp_name = template.t_name;
        this.ticketDetails.sms_temp_id = template.t_id;
        this.GetTicektTemplateDetails(template.t_id, "SMS");
      } else if (type == "WhatsApp") {
        this.WhatsAppTempPreview = "";
        this.ticketDetails.whatsApp_temp_name = template.t_name;
        this.ticketDetails.whatsApp_temp_id = template.t_id;
        this.GetTicektTemplateDetails(template.t_id, "WhatsApp");
      } else if (type == "Ticket") {
        this.TicketTempPreview = "";
        this.ticketDetails.temp_name = template.t_name;
        this.ticketDetails.temp_id = template.t_id;
        this.GetTicektTemplateDetails(template.t_id, "Ticket");
      } else if(type == "Refund") {
        this.RefundTempPreview = "";
        this.ticketDetails.refund_temp_name = template.t_name;
        this.ticketDetails.refund_temp_id = template.t_id;
        this.GetTicektTemplateDetails(template.t_id, "Refund");
      }
    },
    OnSelectReceiptTemplate: function(rtemplate) {
      this.ticketDetails.receipt_temp_name = rtemplate.rtemp_name;
      this.ticketDetails.receipt_temp_id = rtemplate.rtemp_id;
      this.ReceiptTempPreview = "";
      this.GetReceiptTemplateDetails(rtemplate.rtemp_id);
    },

    OnFinalSubmit: function(flag) {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (this.ticketDetails.temp_cinema_id.length == 0) {
          return;
        }
        if (this.ticketDetails.temp_name.length == 0) {
          return;
        }
        if (this.ticketDetails.receipt_temp_name.length == 0) {
          return;
        }
        if (valid) {
          this.btenable = true;
          MasterService.AddCinemaTicketTemplate(this.ticketDetails)
            .then(response => {
              this.btenable = false;
              const { data } = response;

              if (data.status) {
                this.OnReset();
                this.$toasted.show(data.message);

                if (flag) {
                  this.$router.push({
                    path: "/master/cinema-ticket-templates"
                  });
                } else {
                  this.submitted = false;
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>

<style>
.w-62 {
  width: 62%;
}
.TempPreview table {
  border-collapse: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTicketTemplates/addCinemaTicketTemplates.vue